import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConnectionTestResult } from '@core/models';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonBlockComponent } from '@custom-components/general/skeleton/skeleton-block/skeleton-block.component';

@Component({
  selector: 'xemex-connection-test-dialog',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    TranslateModule,
    SkeletonBlockComponent,
  ],
  templateUrl: './connection-test-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './connection-test-dialog.component.scss',
})
export class ConnectionTestDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConnectionTestDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);
  connectionTestResult = input<ConnectionTestResult>();
  isExecutingConnectionTest = input<boolean>();

  constructor() {
    this.connectionTestResult = this.data.connectionTestResult;
    this.isExecutingConnectionTest = this.data.isExecutingConnectionTest;
  }
}
